import { PROFILE_LOAD_REQUESTING, PROFILE_UNLOAD_REQUESTING } from "./constants";

export const loadUserProfile = () => ({
  type: PROFILE_LOAD_REQUESTING,
  payload: {}
});

export const logoutUser = () => ({
  type: PROFILE_UNLOAD_REQUESTING,
  payload: {}
})